import { Component, Input, Output, TemplateRef, ViewChild, EventEmitter } from '@angular/core';
import { CreateSbUserWizardComponent, StarbaseWizardStep } from 'starbase-wizard';
import { IUserAccountModel } from 'starbase-launcher';

@Component({
  selector: 'app-create-sb-user-wrapper',
  templateUrl: './create-sb-user-wrapper.component.html'
})
export class CreateSbUserWrapperComponent {
  @Input() minimumPwdLength;
  @Input() minimumPwdScore;
  @Input() passwordScorerFn;
  @Input() userGroups;
  @Input() emailTakenFn;
  @Input() optionalContactModel;
  @Input() subscriptionBasedApp;
  @Output() wizardCompletedEmitter = new EventEmitter<any>();
  @Output() wizardCancelledEmitter = new EventEmitter<any>();
  overrideSteps: StarbaseWizardStep<IUserAccountModel>[] = [];
  showExpiryDateField;
  today = new Date();
  @ViewChild('rootWizard') rootWizard: CreateSbUserWizardComponent;
  @ViewChild('createSbUserStep2Override', { static: true }) createSbUserStep2Override: TemplateRef<any>;


  setupWizard() {
    if (this.optionalContactModel) {
      this.overrideSteps = this.rootWizard.defaultCreateUserSteps.slice(1);
      this.overrideSteps[1].stepTemplate = this.createSbUserStep2Override;
    } else {
      this.overrideSteps = this.rootWizard.defaultCreateUserSteps;
      this.overrideSteps[2].stepTemplate = this.createSbUserStep2Override;
    }
    this.rootWizard.createUserWizardSteps = this.overrideSteps;
  }

}
